<template>
  <div :class="outerClasses">
    <div :class="containerClasses">
      <!-- Header con sfondo full-width -->
      <div class="bg-white dark:bg-gray-900 shadow-md fixed top-0 left-0 right-0">
        <header class="py-4 px-6 flex justify-between items-center max-w-screen-xl mx-auto">
          <Link :href="route('dashboard')">
            <ApplicationLogo class="h-12 w-12"></ApplicationLogo>
          </Link>
          <div v-if="currentCustomer" class="flex flex-col items-center">
            <img :src="`/images/loghi-clienti/${currentCustomer.slug}.png`" :alt="currentCustomer.name" :class="currentCustomer.slug_override ? 'h-8' : 'h-12'" class="max-w-[150px] sm:max-w-[220px] md:max-w-none object-contain">
            <span v-if="currentCustomer.slug_override" class="text-xs font-semibold text-gray-600 dark:text-gray-300 mt-1 leading-none">{{ currentCustomer.name }}</span>
          </div>
          <div class="relative">
            <button @click="dropdownOpen = !dropdownOpen" class="bg-red-500 dark:bg-red-700 text-white w-10 h-10 flex items-center justify-center rounded-full font-bold">
              {{ getInitials }}
            </button>
            <div v-if="dropdownOpen"  @mouseleave="dropdownOpen = false" class="absolute right-0 mt-2 w-64 z-20 bg-white dark:bg-gray-900 shadow-lg rounded-lg">
                <ul>
                    <li>
                    <Link :href="route('dashboard')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                      </svg>
                      Dashboard
                    </Link>
                    </li>
                    <li>
                    <Link :href="route('profile.show')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 512 512" fill="currentColor">
                      <g>
                        <circle cx="256" cy="128" r="128"/>
                        <path d="M256,298.667c-105.99,0.118-191.882,86.01-192,192C64,502.449,73.551,512,85.333,512h341.333   c11.782,0,21.333-9.551,21.333-21.333C447.882,384.677,361.99,298.784,256,298.667z"/>
                      </g>
                    </svg>
                    {{ $t('ui.user_profile.link_label') }}
                    </Link>
                    <Link v-if="$page.props.isAdminOrSuperAdmin" :href="route('modules.core.gestione-utenti')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                    </svg>
                    {{ $t('ui.user_management') }}
                    </Link>
                    <Link v-if="$page.props.isSuperAdmin" :href="route('modules.core.gestione-policies')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path d="m23.5 17l-5 5l-3.5-3.5l1.5-1.5l2 2l3.5-3.5zM12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0 8c.5 0 .97-.07 1.42-.21c-.27.71-.42 1.43-.42 2.21v.45l-1 .05c-5 0-9.27-3.11-11-7.5c1.73-4.39 6-7.5 11-7.5s9.27 3.11 11 7.5c-.25.64-.56 1.26-.92 1.85c-.9-.54-1.96-.85-3.08-.85c-.78 0-1.5.15-2.21.42c.14-.45.21-.92.21-1.42a5 5 0 0 0-5-5a5 5 0 0 0-5 5a5 5 0 0 0 5 5"></path>
                    </svg>  
                    {{ $t('ui.ui_policy') }}
                    </Link>
                    <Link v-if="$page.props.isSuperAdmin" :href="route('modules.core.gestione-clienti')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10.57,10.99c.23,.13,.48,.19,.73,.19,.53,0,1.04-.28,1.31-.77,.4-.72,.15-1.64-.58-2.04l-.64-.36c.07-.33,.1-.67,.1-1.02s-.04-.69-.1-1.02l.64-.36c.72-.4,.98-1.32,.58-2.04-.4-.72-1.32-.98-2.04-.58l-.65,.36c-.54-.51-1.2-.89-1.92-1.12v-.76c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v.76c-.72,.23-1.38,.61-1.92,1.12l-.65-.36c-.72-.4-1.64-.15-2.04,.58-.4,.72-.15,1.64,.58,2.04l.64,.36c-.07,.33-.1,.67-.1,1.02s.04,.69,.1,1.02l-.64,.36c-.72,.4-.98,1.32-.58,2.04,.27,.49,.79,.77,1.31,.77,.25,0,.5-.06,.73-.19l.65-.36c.54,.51,1.2,.89,1.92,1.12v.76c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-.76c.72-.23,1.38-.61,1.92-1.12l.65,.36Zm-4.07-1.99c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Zm16.03,9.37l-.64-.36c.07-.33,.1-.67,.1-1.02s-.04-.69-.1-1.02l.64-.36c.72-.4,.98-1.32,.58-2.04-.4-.72-1.32-.98-2.04-.58l-.65,.36c-.54-.51-1.2-.89-1.92-1.12v-.76c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v.76c-.72,.23-1.38,.61-1.92,1.12l-.65-.36c-.72-.4-1.64-.15-2.04,.58-.4,.72-.15,1.64,.58,2.04l.64,.36c-.07,.33-.1,.67-.1,1.02s.04,.69,.1,1.02l-.64,.36c-.72,.4-.98,1.32-.58,2.04,.27,.49,.79,.77,1.31,.77,.25,0,.5-.06,.73-.19l.65-.36c.54,.51,1.2,.89,1.92,1.12v.76c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-.76c.72-.23,1.38-.61,1.92-1.12l.65,.36c.23,.13,.48,.19,.73,.19,.53,0,1.04-.28,1.31-.77,.4-.72,.15-1.64-.58-2.04Zm-5.53,.63c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"/>
                    </svg>
                    {{ $t('ui.customer_management') }}
                    </Link>
                    <Link v-if="$page.props.isSuperAdmin" :href="route('modules.core.riepilogo-clienti')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 3h18v2H3V3zm0 4h12v2H3V7zm0 4h18v2H3v-2zm0 4h12v2H3v-2zm0 4h18v2H3v-2z"/>
                    </svg>
                    {{ $t('ui.customer_overview') }}
                    </Link>
                    <Link v-if="$page.props.isSuperAdmin" :href="route('customer-choice')" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                      <path d="m11 22.5c0 .828-.672 1.5-1.5 1.5h-4c-3.032 0-5.5-2.468-5.5-5.5v-13c0-3.032 2.468-5.5 5.5-5.5h7c3.032 0 5.5 2.468 5.5 5.5 0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5c0-1.379-1.121-2.5-2.5-2.5h-7c-1.379 0-2.5 1.121-2.5 2.5v13c0 1.379 1.121 2.5 2.5 2.5h4c.828 0 1.5.672 1.5 1.5zm-4.5-17.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm3.5 1.5c0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5-.672-1.5-1.5-1.5-1.5.672-1.5 1.5zm-3.5 3.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm5 0c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm-5 5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm17.5 3v3c0 1.657-1.343 3-3 3h-5c-1.657 0-3-1.343-3-3v-3c0-.885.39-1.672 1-2.221v-2.279c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5v2.279c.61.549 1 1.336 1 2.221zm-7-4.5v1.5h3v-1.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5zm3 6c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5.672 1.5 1.5 1.5 1.5-.672 1.5-1.5z"/>
                    </svg>
                    {{ $t('ui.change_customer') }}
                    </Link>
                    </li>
                    <li>
                    <Link :href="route('logout')" method="post" as="button" class="block w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-left flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 23 23" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" /><path d="M9 12h12l-3 -3" /><path d="M18 15l3 -3" />
                    </svg>
                    {{ $t('actions.log_out') }}
                    </Link>
                    </li>
                </ul>
            </div>
          </div>
        </header>
      </div>

      <!-- Spazio per non coprire il contenuto sotto l'header -->
      <div class="h-20 flex-none"></div>
      <div v-if="$page.props.hasSplitView || $page.props.fullWidth" class="flex-1 min-h-0 overflow-hidden">
        <slot></slot>
      </div>
      <slot v-else></slot>
    </div>
  </div>
  <div 
    v-if="dropdownOpen" 
    class="fixed inset-0 z-10" 
    @click="dropdownOpen = false"
  >
  </div>

  <Modal :show="detailPopup.show" @close="detailPopup.show = false" max-width="lg">
    <div class="p-6">
      <h3 class="text-lg font-medium text-gray-900 mb-4 border-b pb-2">
        {{ detailPopup.title }}
      </h3>
      <div class="text-sm text-gray-600 break-words whitespace-pre-wrap max-h-[60vh] overflow-y-auto">
        {{ detailPopup.content }}
      </div>
      <div class="mt-6 flex justify-end">
        <button 
          @click="detailPopup.show = false"
          class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 transition-colors"
        >
          {{ $t('actions.close') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Link, usePage } from '@inertiajs/vue3';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import WelcomeUser from '@/Components/WelcomeUser.vue';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Modal from '@/Components/Modal.vue';

export default {
  components: {
    ApplicationLogo,
    Link,
    WelcomeUser,
    BreadCrumbs,
    Modal
  },
  data() {
    return {
      dropdownOpen: false,
      detailPopup: {
        show: false,
        content: '',
        title: ''
      }
    };
  },
  computed: {
    currentCustomer() {
      return this.$page.props.customer;
    },
    getInitials() {
      const user = this.$page.props.auth.user;
      const nameParts = user.name.split(' ');
      if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
      } else {
        return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
      }
    },
    outerClasses() {
      const hasSplitView = this.$page.props.hasSplitView;
      const fullWidth    = this.$page.props.fullWidth;
      const base = 'bg-gray-200 dark:bg-gray-800 flex justify-center overflow-hidden';
      return (hasSplitView || fullWidth) ? `h-screen ${base}` : `min-h-screen ${base}`;
    },
    containerClasses() {
      const baseClasses = 'w-full';
      const isGestioneOrdiniPage = this.$page.url.includes('/modules/gestione-ordini');
      const hasSplitView = this.$page.props.hasSplitView;
      const fullWidth    = this.$page.props.fullWidth;
      const maxWidth     = this.$page.props.maxWidth;

      if ((isGestioneOrdiniPage && hasSplitView) || fullWidth) {
        return `${baseClasses} h-full flex flex-col`;
      }
      if (maxWidth) {
        return `${baseClasses} max-w-screen-${maxWidth}`;
      }
      return `${baseClasses} max-w-screen-xl`;
    }
  },
  mounted() {
    window.addEventListener('click', this.handleGlobalClick, true);
  },
  beforeUnmount() {
    window.removeEventListener('click', this.handleGlobalClick, true);
  },
  methods: {
    handleGlobalClick(e) {
      const target = e.target.closest('.v-data-table__td-value');
      if (target) {
        // Se il click è su un elemento interattivo (o dentro uno di essi), non intervenire
        const interactive = e.target.closest('button, a, input, select, textarea, [role="button"]');
        if (interactive) return;

        // Controlla se il testo è effettivamente troncato (overflowing)
        const isTruncated = target.offsetWidth < target.scrollWidth;
        
        if (isTruncated) {
          // Ferma la propagazione e previene il comportamento di default se troncato
          e.stopPropagation();
          e.preventDefault();
          
          this.detailPopup.content = target.innerText;
          
          // Tenta di recuperare il titolo della colonna
          const cell = target.closest('.v-data-table__td');
          if (cell) {
            const titleEl = cell.querySelector('.v-data-table__td-title');
            if (titleEl) {
              this.detailPopup.title = titleEl.innerText;
            } else {
              this.detailPopup.title = this.$t('ui.details');
            }
          } else {
            this.detailPopup.title = this.$t('ui.details');
          }
          
          this.detailPopup.show = true;
        }
      }
    }
  }
};
</script>